import React from "react";
import { Card, Badge, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ContractDetail = () => {
  const navigate = useNavigate();

  // ✅ Static Contract Data
  const contract = {
    id: "CTR-1001",
    userName: "Rahul Sharma",
    userEmail: "rahul@gmail.com",
    vendorName: "ABC Pvt Ltd",
    vendorEmail: "vendor@abc.com",
    contractDate: "2025-02-01T10:30:00",
    contractAmount: "₹25,000",
    duration: "12 Months",
    status: "Accepted",
    description:
      "This contract is signed between Rahul Sharma and ABC Pvt Ltd for providing software development services for 12 months.",
  };

  return (
    <div className="container mt-4">
      <Button
        variant="secondary"
        className="mb-3"
        onClick={() => navigate(-1)}
      >
        ← Back
      </Button>

      <Card className="shadow-lg border-0">
        <Card.Header
          style={{
            backgroundColor: "#64CAE5",
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
          }}
        >
          Contract Details
        </Card.Header>

        <Card.Body style={{ backgroundColor: "#f9fbfc" }}>
          <div className="row mb-3">
            <div className="col-md-6">
              <h6>Contract ID</h6>
              <p>{contract.id}</p>
            </div>
            <div className="col-md-6">
              <h6>Contract Date</h6>
              <p>
                {new Date(contract.contractDate).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}{" "}
                {new Date(contract.contractDate).toLocaleTimeString("en-IN", {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </p>
            </div>
          </div>

          <hr />

          <div className="row mb-3">
            <div className="col-md-6">
              <h6>User Information</h6>
              <p><strong>Name:</strong> {contract.userName}</p>
              <p><strong>Email:</strong> {contract.userEmail}</p>
            </div>
            <div className="col-md-6">
              <h6>Vendor Information</h6>
              <p><strong>Name:</strong> {contract.vendorName}</p>
              <p><strong>Email:</strong> {contract.vendorEmail}</p>
            </div>
          </div>

          <hr />

          <div className="row mb-3">
            <div className="col-md-6">
              <h6>Contract Amount</h6>
              <p>{contract.contractAmount}</p>
            </div>
            <div className="col-md-6">
              <h6>Duration</h6>
              <p>{contract.duration}</p>
            </div>
          </div>

          <hr />

          <div className="mb-3">
            <h6>Description</h6>
            <p>{contract.description}</p>
          </div>

          <div>
            <h6>Status</h6>
            <Badge
              bg={contract.status === "Accepted" ? "success" : "danger"}
              className="px-3 py-2"
            >
              {contract.status}
            </Badge>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ContractDetail;
